export enum PlasticsTaskType {
    MIXING = "mixing",
    MOLDING = "molding",
    FINISHING = "finishing",
}